"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CONTENTS_STATUS_ARCHIVED = exports.CONTENTS_STATUS_PUBLISHED = exports.CONTENTS_STATUS_DRAFT = exports.CORE_VERSION = void 0;
/* global process */

var CORE_VERSION = '5.7.0';
exports.CORE_VERSION = CORE_VERSION;
var DEFAULTS = {
  REQUEST_RETRY_COUNT: 3,
  REQUEST_RETRY_DELAY: 1000,
  REQUEST_ID_SEARCH: 'REQUEST_ID_SEARCH',
  FEATURE_ENABLED_DRAFT_CONTENT_PREVIEW: false,
  SKIP_PRELOAD_HEROSHOT_IMAGE: false,
  CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
  CLIENT_SECRET: process.env.REACT_APP_CLIENT_SECRET,
  BASE_URL: '',
  MAX_RECENTLY_VIEWED_QUEUE: 10,
  MAX_FAVORITES_QUEUE: null,
  MAX_RATINGS_QUEUE: null,
  DEFAULT_LOCALE: 'en_US',
  DEFAULT_BRAND: '',
  IMAGE_MAPS_ORDER: [],
  PUBLICATIONS_ORDER: [],
  CONTENT_ICONS_ALIASES: {},
  RUNTIME_CONFIG_URI: '/config/parameters.json',
  //------> Analytics setup <-------//
  FULL_STORY_ORG_CODE: null,
  FULL_STORY_DEBUG: false,
  FULL_STORY_ORG_CODE_BY_ENV: {},
  GA_CODES_BY_ENV: {},
  GA_APPLICATION_TYPE: null,
  GOOGLE_ANALYTICS_DEBUG: false,
  //------> Analytics setup END <-------//
  CONTENT_STATIC_HOST: process.env.PUBLIC_URL,
  // TODO: possibly change to CDN?
  DEFAULT_GROUP: 'Cars',
  TEMPORARY_GROUPS: {},
  COMING_SOON_CONTENT: [],
  UI_REM_SIZE: 20,
  BROWSE_ROOT_KEY: "root",
  BROWSE_FOLDERS_KEYS: ['id', 'type', 'title', 'resourceKey', 'contents', 'alias'],
  CONTENT_TYPE_FOLDER: 'folder',
  CONTENT_TYPE_TOPIC: 'topic',
  // Load user's settings stored locally
  LOAD_USER_SETTINGS: false,
  // error logs for web apps
  ERROR_LOG_ENDPOINT: null,
  // ask CD server to set auth cookie
  COOKIE_AUTHENTICATION: true
};
var CONTENTS_STATUS_DRAFT = 'draft';
exports.CONTENTS_STATUS_DRAFT = CONTENTS_STATUS_DRAFT;
var CONTENTS_STATUS_PUBLISHED = 'published';
exports.CONTENTS_STATUS_PUBLISHED = CONTENTS_STATUS_PUBLISHED;
var CONTENTS_STATUS_ARCHIVED = 'archived';
exports.CONTENTS_STATUS_ARCHIVED = CONTENTS_STATUS_ARCHIVED;
var _default = DEFAULTS;
exports.default = _default;